<template>
    <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header py-2">General Information</div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label for="name" class="form-label">Name <span class="text-danger">*</span></label>
                                <Field
                                    name="name"
                                    :value="quotation.name"
                                    v-slot="{ field }"
                                >
                                    <vue-multiselect
                                        v-bind="field"
                                        v-model="quotation.name_select"
                                        :class="{ 'is-invalid': errors.name }"
                                        :options="customerOptions"
                                        placeholder="Search or add new customer"
                                        tag-placeholder="Add this as new customer"
                                        :taggable="true"
                                        :show-labels="false"
                                        track-by="name_with_address"
                                        label="name_with_address"
                                        @tag="addCustomer"
                                        @select="selectCustomer"
                                    ></vue-multiselect>
                                </Field>
                                <div v-if="errors.name" class="is-invalid invalid-feedback">{{ errors.name }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                                <Field
                                    type="email"
                                    class="form-control"
                                    name="email"
                                    placeholder="Enter email"
                                    v-model="quotation.email"
                                    :class="{ 'is-invalid': errors.email }"
                                ></Field>
                                <div v-if="errors.email" class="is-invalid invalid-feedback">{{ errors.email }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="phone" class="form-label">Phone <span class="text-danger">*</span></label>
                                <Field
                                    type="text"
                                    class="form-control"
                                    name="phone"
                                    placeholder="Enter phone"
                                    v-model="quotation.phone"
                                    :class="{ 'is-invalid': errors.phone }"
                                ></Field>
                                <div v-if="errors.phone" class="is-invalid invalid-feedback">{{ errors.phone }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="address" class="form-label">Address <span class="text-danger">*</span></label>
                                <Field
                                    type="text"
                                    class="form-control"
                                    name="address"
                                    placeholder="Enter address"
                                    v-model="quotation.address"
                                    :class="{ 'is-invalid': errors.address }"
                                ></Field>
                                <div v-if="errors.address" class="is-invalid invalid-feedback">{{ errors.address }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="postalCode" class="form-label">Postal Code <span class="text-danger">*</span></label>
                                <Field
                                    type="text"
                                    class="form-control"
                                    name="postal_code"
                                    placeholder="Enter postalCode"
                                    v-model="quotation.postal_code"
                                    :class="{ 'is-invalid': errors.postal_code }"
                                ></Field>
                                <div v-if="errors.postal_code" class="is-invalid invalid-feedback">{{ errors.postal_code }}</div>
                            </div>
                            <div class="col-6">
                                <label for="discount" class="form-label">Status</label>
                                <vue-multiselect
                                    v-model="quotation.status"
                                    :options="[{name: 'pending', label: 'Pending'}, {name: 'confirmed', label: 'Confirmed'}, {name: 'cancelled', label: 'Cancelled'}]"
                                    :searchable="false"
                                    :show-labels="true"
                                    track-by="label"
                                    label="label"
                                ></vue-multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header py-2 d-flex align-items-center justify-content-between">
                        <div>Service & Pricing</div>
                        <button type="button" class="btn btn-sm btn-theme float-end" @click="addMoreServiceItem"><i class="bi bi-plus-circle"></i> Add More</button>
                    </div>
                    <div class="card-body">
                        <table class="table in-table align-middle" id="mannualProduct">
                            <thead>
                            <tr>
                                <th scope="col" width="5%">S.No</th>
                                <!--<th scope="col" width="15%">Service Type</th>-->
                                <th scope="col" width="40%">Service Name</th>
                                <th scope="col" width="15%" class="text-center">Item Cost</th>
                                <th scope="col" width="15%" class="text-center">Labour Cost</th>
                                <!-- <th scope="col">Quantity</th> -->
                                <th scope="col" width="15%" class="text-center">Discount(%)</th>
                                <!-- <th scope="col">VAT (in %)</th> -->
                                <th scope="col" width="10%" class="text-center">Net Amount</th>
                                <th>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in totalServiceItems" :key="item">
                                <td>{{ item }}</td>
                                <!--<td>
                                    <Select2
                                        v-model="quotation.services[item - 1].service_type"
                                        :options="serviceTypes"
                                        :settings="{ placeholder: 'Service Type'}"
                                        :class="{ 'is-invalid': !isValidated && quotation.services[item - 1].service_type==='' }"
                                    />
                                    <div class="is-invalid invalid-feedback">This field is required.</div>
                                </td>-->
                                <td>
                                    <!-- If selected service_type is service then show service list -->
                                    <template v-if="quotation.services[item - 1].service_type === 'service'">
                                        <Field :name="`services.${index}.name`" :value="quotation.services[item - 1].name" v-slot="{ field }">
                                            <vue-multiselect
                                                v-bind="field"
                                                v-model="quotation.services[item - 1].service_select"
                                                :options="serviceOptions"
                                                placeholder="Search or add new service"
                                                tag-placeholder="Add this as new service"
                                                tag-position="bottom"
                                                :show-labels="false"
                                                :taggable="true"
                                                track-by="id"
                                                label="name"
                                                @tag="addService($event, item - 1)"
                                                @select="selectService($event, item - 1)"
                                                :class="{ 'is-invalid': errors[`services[${index}].name`] }"
                                            ></vue-multiselect>
                                        </Field>
                                        <!-- <Select2
                                             v-model="quotation.services[item - 1].service_id"
                                             :options="serviceOptions"
                                             :settings="{ placeholder: 'Select Service'}"
                                             @select="calculateServiceItemAmount('service', item - 1)"
                                             :class="{ 'is-invalid': !isValidated && quotation.services[item - 1].service_id==='' }"
                                         />-->
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </template>
                                    <template v-else-if="quotation.services[item - 1].service_type === 'package'">
                                        <!-- If selected service_type is package then show package list -->
                                        <Select2
                                            v-model="quotation.services[item - 1].package_id"
                                            :options="packageOptions"
                                            :settings="{ placeholder: 'Select Package'}"
                                            @select="calculateServiceItemAmount('package', item - 1)"
                                            :class="{ 'is-invalid': !isValidated && quotation.services[item - 1].package_id==='' }"
                                        />
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </template>
                                    <template v-else>
                                        <Select2
                                            :options="[{id: ' ', text: 'Select Service'}]"
                                            :settings="{ placeholder: 'Select Service'}"
                                            :class="{ 'is-invalid': !isValidated && quotation.services[item - 1].service_id==='' }"
                                        />
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </template>
                                </td>
                                <td class="text-center">
                                    <input
                                        type="text"
                                        name="amount"
                                        class="form-control"
                                        placeholder="Item Cost"
                                        v-model="quotation.services[item - 1].amount"
                                        @keypress="allowNumbersOnly"
                                        @keydown="handleSpecialKeys"
                                        :class="{ 'is-invalid': !isValidated && quotation.services[item - 1].amount==='' }"
                                    >
                                    <div class="is-invalid invalid-feedback">This field is required.</div>
                                </td>
                                <td class="text-center">
                                    <input
                                        type="text"
                                        name="labour_cost"
                                        class="form-control"
                                        placeholder="Labour Cost"
                                        v-model="quotation.services[item - 1].labour_cost"
                                        @keypress="allowNumbersOnly"
                                        @keydown="handleSpecialKeys"
                                        :class="{ 'is-invalid': !isValidated && quotation.services[item - 1].labour_cost==='' }"
                                    >
                                    <div class="is-invalid invalid-feedback">This field is required.</div>
                                </td>
                                <td class="text-center">
                                    <input
                                        type="text"
                                        name="discount"
                                        class="form-control"
                                        placeholder="Enter discount percentage"
                                        v-model="quotation.services[item - 1].discount"
                                        @input="validateInput('service', (item - 1))"
                                        @keypress="allowNumbersOnly"
                                        @keydown="handleSpecialKeys"
                                    >
                                </td>
                                <td class="text-center">
                                    £{{ quotation.services[item - 1].total_amount }}
                                </td>
                                <td class="text-center">
                                    <button
                                        v-if="Object.keys(quotation.services).length > 1"
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        @click="removeOrderItem(item - 1)"
                                        style="left: 30px"
                                    >
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-end">
            <div class="col-7">
                <div class="card">
                    <div class="card-body pt-3">
                        <div class="row g-3">
                            <div class="col-md-12">
                                <label for="comment" class="form-label">Comment</label>
                                <textarea class="form-control" id="comment" v-model="quotation.comment" rows="3" placeholder="Enter comment"></textarea>
                            </div>
                            <div class="col-md-12">
                                <label for="description" class="form-label">Attachment</label>
                                <div class="input-group mb-3">
                                    <input type="file" class="form-control" multiple @change="onFileChange">
                                </div>

                                <!-- Display image preview -->
                                <img v-for="previewImage in previewOrderImages"
                                     :src="previewImage"
                                     class="img-thumbnail me-2 mb-2"
                                     style="{ max-height: 150px; max-width: 150px; }"
                                     :key="previewImage"
                                >

                                <!--Display image in case of edit-->
                                <template
                                    v-if="data && data.quotation_meta.length > 0"
                                    v-for="meta in data.quotation_meta"
                                >
                                    <img
                                        v-if="meta.meta_key === 'images' && meta.meta_value !== ''"
                                        v-for="image in meta.meta_value"
                                        :src="'/uploads/quotations/' + image.file_name"
                                        class="img-thumbnail me-2 mb-2"
                                        style="{ max-height: 150px; max-width: 150px; }"
                                        :key="image"
                                    >
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-5">
                <div class="card">
                    <Div class="card-header py-2">Calculation</Div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="discount" class="form-label">Total Amount</label>
                                <input
                                    readonly
                                    type="text"
                                    class="form-control"
                                    v-model="quotation.amount"
                                />
                            </div>
                            <div class="col-6">
                                <label for="discount" class="form-label">Gross Discount(%)</label>
                                <input
                                    name="discount"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter discount"
                                    v-model="quotation.discount"
                                    @input="validateInput('order', 1)"
                                    @keypress="allowNumbersOnly"
                                    @keydown="handleSpecialKeys"
                                />
                            </div>
                            <div class="col-6">
                                <label for="discount" class="form-label">Gross Discount</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    readonly
                                    v-model="quotation.discount_amount"
                                />
                            </div>
                            <div class="col-12">
                                <label for="discount" class="form-label">Gross Amount</label>
                                <input
                                    readonly
                                    type="text"
                                    class="form-control"
                                    :value="quotation.amount - quotation.discount_amount"
                                />
                            </div>

                            <div class="col-6">
                                <label for="discount" class="form-label">VAT Amount(%)</label>
                                <vue-multiselect
                                    v-model="quotation.tax"
                                    :options="[0, tax]"
                                    :searchable="false"
                                    :show-labels="false"
                                ></vue-multiselect>
                            </div>
                            <div class="col-6">
                                <label for="discount" class="form-label">VAT Amount</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    readonly
                                    v-model="quotation.tax_amount"
                                />
                            </div>
                            <!-- </div> -->
                            <div class="col-12">
                                <label for="total_amount" class="form-label">Net Price</label>
                                <input
                                    name="total_amount"
                                    type="text"
                                    class="form-control"
                                    readonly
                                    :value="'£' + quotation.total_amount"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button
                    type="submit"
                    class="btn btn-theme float-end"
                    v-text="isProcessing ? 'Processing...' : (addOrEdit === 'add' ? 'Create' : 'Update')"
                    :disabled="isProcessing || !isFormValid"
                    :class="{'disabled': isProcessing || !isFormValid}"
                    @click="handleSubmit($event, createQuotation)"
                ></button>
            </div>
        </div>
    </Form>
</template>
<script>
import Select2 from 'vue3-select2-component';
import moment from 'moment';
import {Field} from "vee-validate";
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        quotationNumber: {
            type: String,
            default: ''
        }
    },
    components: {
        Field,
        Select2
    },
    data() {
        return {
            addOrEdit: this.data ? 'edit' : 'add',
            isProcessing: false,
            isFormValid: true, // default should be false
            serviceType: 'service', // package or service
            services: [],
            packages: [],
            serviceOptions: [],
            packageOptions: [],
            previewOrderImages: [],
            totalServiceItems: 1,
            isValidated: true,
            tax: 20,
            quotation: {
                name_select: null,
                name: null,
                email: '',
                phone: '',
                address: '',
                city: '',
                state: '',
                country: '',
                postal_code: '',
                status: {name: 'pending', label: 'Pending'},
                tax: 20, // in percentage
                discount: 0,
                amount: 0,
                item_price: 0,
                labour_cost: 0,
                discount_amount: 0,
                tax_amount: 0,
                total_amount: 0,
                comment: '',
                files: [],
                services: [
                    {
                        service_select: null,
                        service_type: 'service',
                        name: '',
                        service_id: '',
                        package_id: '',
                        tax: 20,
                        discount: '', // in percentage
                        amount: '',
                        labour_cost: '',
                        discount_amount: 0,
                        tax_amount: 0,
                        total_amount: 0,
                        total_with_tax: 0
                    }
                ]
            },
            //schema: {
            //    name: 'required',
            //    email: 'required|email',
            //    phone: 'required',
            //    address: 'required',
            //    postal_code: 'required',
            //    services: {
            //        '*': {
            //            name: 'required',
            //        }
            //    }
            //},
            customerOptions: [],
        }
    },
    created() {
        this.getServicesForOrder();
        this.getUsersWithAddress();

        // Check if data is not empty
        if (this.data) {
            this.quotation.name = this.data.name;
            this.quotation.email = this.data.email;
            this.quotation.phone = this.data.phone;
            this.quotation.address = this.data.address;
            this.quotation.city = this.data.city;
            this.quotation.state = this.data.state;
            this.quotation.country = this.data.country;
            this.quotation.postal_code = this.data.postal_code;
            this.quotation.status = {name:this.data.status, label: this.$capitalize(this.data.status) };
            //this.quotation.tax = this.data.tax;
            //this.quotation.discount = this.data.discount_amount;
            //this.quotation.amount = this.data.amount;
            //this.quotation.item_price = this.data.item_price;
            //this.quotation.labour_cost = this.data.labour_cost;
            this.quotation.discount_amount = this.data.discount_amount;
            this.quotation.tax_amount = this.data.tax_amount;
            this.quotation.total_amount = this.data.total_amount;
            this.quotation.name_select = {
                name: this.data.name,
                email: this.data.email,
                phone: this.data.phone,
                name_with_address: this.data.name + ' - ' + this.data.address + ',' + this.data.postal_code,
                address: this.data.address,
                postal_code: this.data.postal_code
            };

            // updated the service items
            if (this.data.quotation_items.length > 0) {
                this.quotation.services = [];
                this.data.quotation_items.forEach((item) => {
                    this.quotation.services.push({
                        id: item.id,
                        name: item.service_name,
                        service_type: item.item_type,
                        service_id: item.service_id,
                        package_id: item.service_package_id,
                        tax: item.tax,
                        discount: item.discount_value, // in percentage
                        discount_amount: item.discount_amount,
                        labour_cost: item.labour_cost,
                        amount: item.price,
                        tax_amount: item.tax_amount,
                        total_amount: item.total_amount,
                        total_with_tax: item.total_amount,
                        service_select: {
                            id: item.id,
                            name: item.service_name,
                            category_id: item.category_id,
                            price: item.price,
                            labour_cost: item.labour_cost,
                            discount: item.discount,
                            price_type: item.price_type,
                            recurring_services: item.recurring_services
                        }
                    });
                });

                this.totalServiceItems = this.data.quotation_items.length;
            }
            // Updated the comment
            if (this.data.quotation_meta.length > 0) {
                this.quotation.comment = '';
                this.data.quotation_meta.forEach((meta) => {
                    if (meta.meta_key == 'comment') {
                        this.quotation.comment = meta.meta_value;
                    }
                })

            }
        }
    },
    mounted() {
    },
    computed: {
        // Generate dynamic schemas for each service item
        schema() {
            const schemas = {
                name: 'required',
                email: 'required|email',
                phone: 'required',
                address: 'required',
                postal_code: 'required',
            };
            this.quotation.services.forEach((item, index) => {
                console.log(item.name, index);
                schemas[`services.${index}.name`] = 'required';
                // Add other properties (itemCost, laborCost, etc.) as needed
            });
            return schemas;
        }
    },
    methods: {
        getServicesForOrder() {
            let self = this;
            axios.post('/admin/services/get-services-for-order', {})
                .then(response => {
                    self.services = response.data.services;
                    self.packages = response.data.packages;

                    // Prepare service options
                    self.serviceOptions = [];
                    response.data.services.forEach((service) => {
                        self.serviceOptions.push({
                            id: service.id,
                            name: service.name,
                            category_id: service.category_id,
                            price: service.price,
                            labour_cost: service.labour_cost,
                            discount: service.discount,
                            price_type: service.price_type,
                            recurring_services: service.recurring_services
                        });
                    });

                    // Prepare package options
                    self.packageOptions = [{id: ' ', text: 'Select Package'}];
                    response.data.packages.forEach((packageItem) => {
                        self.packageOptions.push({id: packageItem.id, text: packageItem.name});
                    });
                });
        },
        onFileChange(event) {
            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();

                    // Display the image preview
                    reader.onload = (e) => {
                        this.previewOrderImages.push(e.target.result);
                    }
                    reader.readAsDataURL(file); // Not sure if this will work in this context.
                    this.quotation.files.push(file);
                } catch {}
            }
        },
        addMoreServiceItem() {
            this.totalServiceItems++;
            this.quotation.services.push({
                service_type: 'service',
                name: '',
                service_id: '',
                package_id: '',
                tax: 20,
                discount: '',
                amount: '',
                labour_cost: '',
                discount_amount: 0,
                tax_amount: 0,
                total_amount: 0,
                total_with_tax: 0
            });
        },
        removeOrderItem(index) {
            this.totalServiceItems--;
            this.quotation.services.splice(index, 1);
            this.quotation.services = this.quotation.services.filter(function(){return true;});
        },
        calculateServiceItemAmount(type, index) {
            let self = this;
            let serviceDetail = {};
            if (type == 'service') {
                // Get the service detail
                serviceDetail = self.services.find(service => service.id == self.quotation.services[index].service_id);
            }
            else if (type == 'package') {
                serviceDetail = this.packages.find(servicePackage => servicePackage.id == this.quotation.services[index].package_id);
            }
            console.log(serviceDetail, index);

            // Check if serviceDetail is not empty then update the amount in quotation.services
            let amount = 0;
            let LabourCost = 0;
            if (serviceDetail && Object.keys(serviceDetail).length > 0) {
                amount = serviceDetail.price;
                LabourCost = serviceDetail.labour_cost;
            }

            this.quotation.services[index].amount = amount;
            this.quotation.services[index].labour_cost = LabourCost;
            this.quotation.services[index].total_amount = amount;
            this.quotation.services[index].total_with_tax = amount;
        },
        calculateServiceTotalAmount(service) {
            // Calculate total amount for each service considering discount
            const amount                = Number(service.amount) || 0;
            const LabourCost            = Number(service.labour_cost) || 0;
            const discountPercentage    = Number(service.discount) || 0;
            const amountWithLabour      = amount + LabourCost;
            const discount              = (amountWithLabour * discountPercentage) / 100;

            // Get discount on the item price
            let itemDiscount = (amount*discountPercentage) / 100;

            // Get the discount on the labour
            let itemLabourDiscount = (LabourCost*discountPercentage) / 100;

            // Get the item price, labour price and final price after discount
            let itemTotalAmount         = amount - itemDiscount;
            let itemLabourTotalAmount   = LabourCost - itemLabourDiscount;
            let discountedAmount        = amountWithLabour - discount;

            // Apply the 20% vat on the discounted amount
            let taxRate     = service.tax;
            const taxAmount = (discountedAmount * taxRate) / 100;

            // Get the final amount
            let totalWithTax = discountedAmount + taxAmount;

            // Update the service tax amount in the order object
            service.tax_amount      = parseFloat(taxAmount).toFixed(2);
            service.discount_amount = parseFloat(discount).toFixed(2);
            service.total_amount    = parseFloat(discountedAmount).toFixed(2);
            service.total_with_tax  = parseFloat(totalWithTax).toFixed(2);

            return {
                itemTotalAmount: itemTotalAmount,
                itemLabourTotalAmount: itemLabourTotalAmount,
                finalAmount: discountedAmount,
            };
        },
        calculateTotalAmount() {
            // Calculate total amount for all services
            let totalAmount = 0;
            let totalItemAmount = 0;
            let totalLabourCost = 0;

            this.quotation.services.forEach((service) => {
                let serviceTotal = this.calculateServiceTotalAmount(service);

                totalItemAmount += serviceTotal.itemTotalAmount;
                totalLabourCost += serviceTotal.itemLabourTotalAmount;
                totalAmount += serviceTotal.finalAmount;
            });

            // Get the overall discount
            const discountPercentage    = Number(this.quotation.discount) || 0;
            const discount              = (totalAmount * discountPercentage) / 100;
            const discountedAmount      = totalAmount - discount;

            // Apply the 20% vat on the discounted amount
            const vat       = (discountedAmount * this.quotation.tax) / 100;
            let finalAmount = discountedAmount + vat;

            // Place only two decimal places
            totalAmount = parseFloat(totalAmount).toFixed(2);
            finalAmount = parseFloat(finalAmount).toFixed(2);

            // Update the total amount in the order object
            this.quotation.amount           = totalAmount;
            this.quotation.item_price       = parseFloat(totalItemAmount).toFixed(2);
            this.quotation.labour_cost      = parseFloat(totalLabourCost).toFixed(2);
            this.quotation.discount_amount  = parseFloat(discount).toFixed(2);
            this.quotation.tax_amount       = parseFloat(vat).toFixed(2);
            this.quotation.total_amount     = finalAmount;
        },
        validateInput(type, index) {
            // Ensure the entered value is not greater than 100
            if (type === 'service') {
                if (this.quotation.services[index].discount > 100) {
                    this.quotation.services[index].discount = 100;
                }
            }

            else if(type === 'quotation') {
                if (this.quotation.discount > 100) {
                    this.quotation.discount = 100;
                }
            }
        },
        allowNumbersOnly(event) {
            // Allow only numeric input
            const charCode = event.charCode;
            // allow only number keys and numpad number keys
            if (
                (charCode >= 48 && charCode <= 57) ||  // Regular number keys
                (charCode >= 96 && charCode <= 105)  // Numpad number keys
            ) {
                return;
            }
        },
        handleSpecialKeys(event) {
            // Handle special keys like arrow keys, delete, and backspace
            const specialKeys = [8, 46, 37, 39];
            if(specialKeys.includes(event.keyCode) || ((event.keyCode >= 48 && event.keyCode <= 57) ||(event.keyCode >= 96 && event.keyCode <= 105))) {
                return;
            }
            event.preventDefault();
        },
        createQuotation() {
            let self = this;
            this.isProcessing = true;
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            }
            const formData = new FormData();
            Object.keys(this.quotation).forEach(key => {
                formData.append(key, this.quotation[key]);
            });

            // Log FormData to ensure it contains the expected data
            for (let pair of formData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }

            // Check for crete or update
            let route = '/admin/quotations';
            if (this.data) {
                route = '/admin/quotations/update-quotation/' + this.data.id;
            }
            axios.post(route, this.quotation, config)
                .then(response => {
                    if (response.data.status === 'success') {
                        window.location.href = response.data.redirect_url;
                    }
                });

        },
        // Get quotation detail for edit
        getQuotationDetails() {
            let self = this;
            axios.post('/admin/quotations/get-details',{quotation: this.quotationNumber})
                .then(response => {
                    if (response.data.status === 'success') {
                        self.quotationDetail = response.data.quotation;
                    }
                });
        },
        getUsersWithAddress() {
            let self = this;
            axios.post('/admin/users/get-address-list', {})
                .then(response => {
                    self.customerOptions = [];
                    if (Object.keys(response.data.addresses).length > 0) {
                        response.data.addresses.forEach((user) => {
                            self.customerOptions.push({
                                name: user.customer_name,
                                email: user.customer_email,
                                phone: user.customer_phone_number,
                                name_with_address: user.name_with_address,
                                address: user.address,
                                postal_code: user.postal_code
                            });
                        });
                    }
                });
        },
        addCustomer(newCustomer) {
            const tag = {
                name: newCustomer,
                email: '',
                phone: '',
                name_with_address: newCustomer,
                address: '',
                postal_code: ''
            }
            this.customerOptions.push(tag)
            this.quotation.name_select = tag;
            this.quotation.name = newCustomer;
        },
        selectCustomer(event) {
            this.quotation.name = event.name;
            this.quotation.email = event.email;
            this.quotation.address = event.address;
            this.quotation.postal_code = event.postal_code;
            this.quotation.phone = event.phone;
        },
        addService(newService, index) {
            const tag = {
                id: '',
                name: newService,
                category_id: '',
                price: '',
                labour_cost: '',
                discount: '',
                price_type: '',
                recurring_services: 0
            }
            this.serviceOptions.push(tag);
            this.quotation.services[index].service_select = tag;
            this.quotation.services[index].name = newService;
        },
        selectService(event, index) {
            this.quotation.services[index].service_id = event.id || '';
            this.quotation.services[index].name = event.name || '';
            this.quotation.services[index].amount = event.price || 0;
            this.quotation.services[index].labour_cost = event.labour_cost || 0;
            this.quotation.services[index].discount = event.discount || '';

            this.calculateServiceItemAmount('service', index);
        }
    },
    watch: {
        'quotation.services': {
            handler(newServices, oldServices) {
                console.log("updated")
                // Recalculate the total amount and total discount for all services
                this.calculateTotalAmount();
            },
            deep: true,
        },
        'quotation.discount': function(newDiscount, oldDiscount) {
            // Recalculate the total amount for all services
            this.calculateTotalAmount();
        },
        // When change the TAX amount
        'quotation.tax': function(newTax, oldTax) {
            // Recalculate the total amount for all services
            this.calculateTotalAmount();
        }
    }
}
</script>
<style scoped>
.multiselect {
    min-height: 36px !important;
}
</style>
